if (!customElements.get("product-info")) {
  const calculateAvailability = (variant) => {
    const variantQuantity =
      productVariantQuantities[variant?.id].inventoryQuantity || 0;
    const deliveryDate =
      productVariantQuantities[variant?.id].deliveryDate || "";
    const continueSelling =
      productVariantQuantities[variant?.id].continueSelling === "continue";

    let availability = "outOfStock";
    switch (true) {
      case (variant.available && variantQuantity > 5) || continueSelling:
        availability = "more5";
        break;
      case variant.available && variantQuantity > 0:
        availability = "5orLess";
        break;
      case !!deliveryDate:
        availability = "outOfStockAndContinueSelling";
        break;
    }

    return [availability, variantQuantity, deliveryDate];
  };

  const generateDeliveryInfoMarkup = (
    availability,
    dataset,
    amount,
    deliveryDate
  ) => {
    const availabilityColors = {
      more5: "#748B46",
      "5orLess": "#ffa500",
      outOfStockAndContinueSelling: "#808080",
      outOfStock: "#9B1E20",
    };

    const availabilityTexts = {
      more5: dataset["more-5Text"],
      "5orLess": dataset["5OrLessText"],
      outOfStockAndContinueSelling: dataset.outOfStockContinueSellingText,
      outOfStock: dataset.outOfStockText,
    };

    const numberRegex = /\d/;
    let replaceText = availabilityTexts[availability];
    switch (availability) {
      case "outOfStockAndContinueSelling":
        replaceText = availabilityTexts[availability] + deliveryDate;
        break;

      case "5orLess":
        replaceText = replaceText.replace(numberRegex, amount);
        break;
    }

    let color = "green";
    switch (availability) {
      case "outOfStock":
        color = "red";
        break;

      case "5orLess":
        color = "yellow";
        break;

      case "outOfStockAndContinueSelling":
        color = "gray";
        break;
    }

    return `<span class="delivery-info__icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
      >
        <circle cx="6" cy="6" r="6" fill="${availabilityColors[availability]}" />
      </svg>
    </span>
    <span class="delivery-info__text ${color}">${replaceText}</span>
    `;
  };

  const updateDeliveryInfo = (variant) => {
    const deliveryInfo = document.querySelector(".js-delivery-info");
    const [availability, amount, deliveryDate] = calculateAvailability(variant);
    if (deliveryInfo) {
      deliveryInfo.innerHTML = generateDeliveryInfoMarkup(
        availability,
        deliveryInfo.dataset,
        amount,
        deliveryDate
      );
    }
  };

  const updatePickUpInfoAJAX = (variant) => {
    if (!variant?.id) {
      console.error("Invalid variant provided");
      return;
    }

    fetch(
      window.Shopify.routes.root +
        `variants/${variant.id}/?section_id=pickup-availability-custom`
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.text();
      })
      .then((text) => {
        const container = document.querySelector(
          ".js-click-and-collect-wrapper"
        );
        if (!container) {
          throw new Error("Container element not found");
        }
        container.innerHTML = "";

        const pickupAvailabilityHTML = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector(".shopify-section");

        if (!pickupAvailabilityHTML) {
          throw new Error(
            "Pickup availability section not found in the response"
          );
        }

        container.innerHTML = pickupAvailabilityHTML.innerHTML;

        pickUpFunctionality();
      })
      .catch((e) => {
        console.error("Error updating pickup info:", e);
      });
  };

  const pickUpFunctionality = () => {
    const clickAndCollectDialog = document.querySelector(
      ".js-click-and-collect__dialog"
    );
    const dialogOpenButton = document.querySelector(
      ".js-click-and-collect__button"
    );
    const dialogCloseButton = document.querySelector(
      ".js-click-and-collect__close-button"
    );
    if (!clickAndCollectDialog) {
      return;
    }
    dialogOpenButton.addEventListener("click", function pickUpOpener(e) {
      clickAndCollectDialog.showModal();
    });

    dialogCloseButton.addEventListener("click", (e) => {
      clickAndCollectDialog.close();
    });

    clickAndCollectDialog.addEventListener("click", (e) => {
      const dialogDimensions = clickAndCollectDialog.getBoundingClientRect();
      if (
        e.clientX < dialogDimensions.left ||
        e.clientX > dialogDimensions.right ||
        e.clientY < dialogDimensions.top ||
        e.clientY > dialogDimensions.bottom
      ) {
        clickAndCollectDialog.close();
      }
    });
  };

  const updatePickUpInfo = (variant) => {
    updatePickUpInfoAJAX(variant);
  };

  customElements.define(
    "product-info",
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();

        this.quantityInput = this.querySelector(".quantity__input");
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        this.dispatchEvent(
          new CustomEvent("product-info:loaded", { bubbles: true })
        );
      }

      setVariantAvailability() {
        fetch(
          window.Shopify.routes.root +
            "variants/[variant-id]/?section_id=pickup-availability"
        )
          .then((response) => response.text())
          .then((text) => {
            const container = document.querySelector(
              "[data-store-availability-container]"
            );
            const pickupAvailabilityHTML = new DOMParser()
              .parseFromString(text, "text/html")
              .querySelector(".shopify-section");

            container.appendChild(pickupAvailabilityHTML);
          })
          .catch((e) => {
            console.error(e);
          });
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector(".product-form__quantity");
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(
            PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this)
          );
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html
            .querySelectorAll(".scroll-trigger")
            .forEach((element) =>
              element.classList.add("scroll-trigger--cancel")
            )
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
          publish(PUB_SUB_EVENTS.sectionRefreshed, {
            data: {
              sectionId: this.sectionId,
              resource: {
                type: SECTION_REFRESH_RESOURCE_TYPE.product,
                id: newNode.dataset.productId,
              },
            },
          });
        });
      }

      handleOptionValueChange({
        data: { event, target, selectedOptionValues },
      }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        const productUrl =
          target.dataset.productUrl ||
          this.pendingRequestUrl ||
          this.dataset.url;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage =
          !this.isFeaturedProduct && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(
            productUrl,
            selectedOptionValues,
            shouldFetchFullPage
          ),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl)
            : this.handleUpdateProductInfo(
                productUrl,
                selectedOptionValues.length === 1
                  ? selectedOptionValues[0]
                  : selectedOptionValues[1]
              ),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      get isFeaturedProduct() {
        return this.dataset.section.includes("featured_product");
      }

      handleSwapProduct(productUrl) {
        return (html) => {
          this.productModal?.remove();

          // Grab the selected variant from the new product info
          const variant = this.getSelectedVariant(
            html.querySelector(`product-info[data-section=${this.sectionId}]`)
          );
          this.updateURL(productUrl, variant?.id);

          // If we are in an embedded context (quick add, featured product, etc), only swap product info.
          // Otherwise, refresh the entire page content and sibling sections.
          if (this.dataset.updateUrl === "false") {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector("product-info"),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            document.querySelector("head title").innerHTML =
              html.querySelector("head title").innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector("main"),
              html.querySelector("main"),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        this.pendingRequestUrl = requestUrl;
        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === "AbortError") {
              console.log("Fetch aborted by user");
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector(
          "variant-selects [data-selected-variant]"
        )?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(
        url,
        optionValues,
        shouldFetchFullPage = false
      ) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(",")}`);
        }

        return `${url}?${params.join("&")}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector("variant-selects");
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(
            this.variantSelectors,
            variantSelects,
            this.preProcessHtmlCallbacks
          );
        }
        document.querySelectorAll("select.select__select").forEach((select) => {
          const optionToSelect = select.querySelector(
            `option[data-option-value-id="${window.selectedValueId}"]`
          );

          if (optionToSelect) {
            optionToSelect.selected = true;

            // // Trigger change event
            // const changeEvent = new Event("change", { bubbles: true });
            // select.dispatchEvent(changeEvent);
          }
        });
      }

      changePrice(newPrice, newCompareAtPrice) {
        const formatPrice = (priceInCents) => {
          return new Intl.NumberFormat("de-DE", {
            style: "currency",
            currency: "EUR",
          }).format(priceInCents / 100);
        };

        const productInfo = document.querySelector("product-info");
        const compareAtPriceElem = productInfo.querySelector(
          ".js-product-price-block-compare-price"
        );
        const priceElem = productInfo.querySelector(
          ".js-product-price-block-price"
        );
        const percentageElem = productInfo.querySelector(
          ".js-product-price-block-percentage"
        );

        const newPercentage = Math.round(
          ((newCompareAtPrice - newPrice) / newCompareAtPrice) * 100
        );
        const showCompare = newPercentage >= 5;

        priceElem.textContent = formatPrice(newPrice);

        if (
          compareAtPriceElem &&
          newCompareAtPrice &&
          newCompareAtPrice > newPrice &&
          showCompare
        ) {
          compareAtPriceElem.textContent = formatPrice(newCompareAtPrice);
          compareAtPriceElem.classList.remove("hidden");
          priceElem.classList.add("--discounted");
        } else {
          compareAtPriceElem.classList.add("hidden");
          priceElem.classList.remove("--discounted");
        }

        if (percentageElem && newPercentage >= 5) {
          percentageElem.textContent = newPercentage + " %";
          percentageElem.classList.remove("hidden");
        } else {
          percentageElem.classList.add("hidden");
        }
      }

      handleUpdateProductInfo(productUrl, selectedValueId) {
        return (html) => {
          const variant = this.getSelectedVariant(html);

          const mobileActivator = document.querySelector(
            ".js-swatch-input__too-much--mobile"
          );
          const desktopActivator = document.querySelector(
            ".js-swatch-input__too-much--desktop"
          );

          const variantsExtrudedDesktop = desktopActivator
            ? desktopActivator.classList.contains("clicked")
            : false;
          const variantsExtrudedMobile = mobileActivator
            ? mobileActivator.classList.contains("clicked")
            : false;
          window.selectedValueId = selectedValueId;
          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable();
            updatePickUpInfo(variant);
            return;
          }

          this.updateMedia(html, variant?.featured_media?.id);

          const updateSourceFromDestination = (
            id,
            shouldHide = (source) => false
          ) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(
              `#${id}-${this.dataset.section}`
            );
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle("hidden", shouldHide(source));
            }
          };

          this.changePrice(variant.price, variant.compare_at_price);
          updateSourceFromDestination("Sku", ({ classList }) =>
            classList.contains("hidden")
          );
          updateSourceFromDestination(
            "Inventory",
            ({ innerText }) => innerText === ""
          );
          updateSourceFromDestination("Volume");
          updateSourceFromDestination("Price-Per-Item", ({ classList }) =>
            classList.contains("hidden")
          );
          updateDeliveryInfo(variant);
          updatePickUpInfo(variant);

          const skuHolder = document.querySelectorAll(
            ".js-product-description__sku-holder"
          );
          Array.from(skuHolder).forEach((span) => {
            span.innerText = variant.sku;
          });

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(
            `#Quantity-Rules-${this.dataset.section}`
          )?.classList.remove("hidden");
          this.querySelector(
            `#Volume-Note-${this.dataset.section}`
          )?.classList.remove("hidden");

          this.productForm?.toggleSubmitButton(
            html
              .getElementById(`ProductSubmitButton-${this.sectionId}`)
              ?.hasAttribute("disabled") ?? true,
            window.variantStrings.soldOut
          );

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });

          const mobileActivatorNew = document.querySelector(
            ".js-swatch-input__too-much--mobile"
          );
          const desktopActivatorNew = document.querySelector(
            ".js-swatch-input__too-much--desktop"
          );

          if (desktopActivatorNew && variantsExtrudedDesktop) {
            desktopActivatorNew.classList.add("clicked");
          }

          if (mobileActivatorNew && variantsExtrudedMobile) {
            mobileActivatorNew.classList.add("clicked");
          }

          const sectionId = "product-description";
          const productDescriptionSection = document.querySelector(
            ".js-product-details"
          );
          const url = new URL(window.location.href);
          url.searchParams.set("sections", sectionId);
          fetch(url)
            .then((response) => response.text())
            .then((jsonString) => {
              const { "product-description": productDescription } =
                JSON.parse(jsonString);
              const parser = new DOMParser();
              const doc = parser.parseFromString(
                productDescription,
                "text/html"
              );
              const productDetailsHTML =
                doc.querySelector(".js-product-details")?.innerHTML || "";
              if (productDescriptionSection) {
                productDescriptionSection.innerHTML = productDetailsHTML;
              }
            })
            .catch((error) => console.error("Error fetching section:", error));

          document
            .querySelector(".js-product-variants-parent")
            .dispatchEvent(new Event("change", { bubbles: true }));
        };
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? "";
          input.dispatchEvent(new Event("change", { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        this.querySelector("share-button")?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ""}`
        );

        if (this.dataset.updateUrl === "false") return;
        window.history.replaceState(
          {},
          "",
          `${url}${variantId ? `?variant=${variantId}` : ""}`
        );
      }

      setUnavailable() {
        let isBitteWahlen = false;
        const select = document.querySelector(".select__select");
        if (select) {
          const selectedOption = select.options[select.selectedIndex];
          if (selectedOption?.id === "bittewahlen") {
            isBitteWahlen = true;
          }
        }

        this.productForm?.toggleSubmitButton(
          true,
          isBitteWahlen
            ? window.variantStrings.addToCart
            : window.variantStrings.unavailable
        );

        const selectors = [
          "Inventory",
          "Sku",
          "Price-Per-Item",
          "Volume-Note",
          "Volume",
          "Quantity-Rules",
        ]
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(", ");

        document
          .querySelectorAll(selectors)
          .forEach(({ classList }) => classList.add("hidden"));
      }

      updateMedia(html, variantFeaturedMediaId) {
        const mediaGallerySource = this.querySelector("media-gallery ul");
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          const mediaGallerySourceItems = Array.from(
            mediaGallerySource.querySelectorAll("li[data-media-id]")
          );
          const sourceSet = new Set(
            mediaGallerySourceItems.map((item) => item.dataset.mediaId)
          );
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [
              item.dataset.mediaId,
              { item, index },
            ])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] =
            refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll("li[data-media-id]")
          );
          const destinationSet = new Set(
            mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId)
          );
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (
              !sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)
            ) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (
              !destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)
            ) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh)
            [mediaGallerySourceItems, sourceSet, sourceMap] =
              refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach(
            (destinationItem, destinationIndex) => {
              const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

              if (sourceData && sourceData.index !== destinationIndex) {
                mediaGallerySource.insertBefore(
                  sourceData.item,
                  mediaGallerySource.querySelector(
                    `li:nth-of-type(${destinationIndex + 1})`
                  )
                );

                // refresh source now that it has been modified
                [mediaGallerySourceItems, sourceSet, sourceMap] =
                  refreshSourceData();
              }
            }
          );
        }

        if (variantFeaturedMediaId) {
          // set featured media as active in the media gallery
          this.querySelector(`media-gallery`)?.setActiveMedia?.(
            `${this.dataset.section}-${variantFeaturedMediaId}`,
            true
          );

          // update media modal
          const modalContent = this.productModal?.querySelector(
            `.product-media-modal__content`
          );
          const newModalContent = html.querySelector(
            `product-modal .product-media-modal__content`
          );
          if (modalContent && newModalContent)
            modalContent.innerHTML = newModalContent.innerHTML;
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity
            ? parseInt(this.quantityInput.dataset.cartQuantity)
            : 0,
          min: this.quantityInput.dataset.min
            ? parseInt(this.quantityInput.dataset.min)
            : 1,
          max: this.quantityInput.dataset.max
            ? parseInt(this.quantityInput.dataset.max)
            : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute("max");
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;
        this.querySelector(
          ".quantity__rules-cart .loading__spinner"
        ).classList.remove("hidden");
        fetch(
          `${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`
        )
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() =>
            this.querySelector(
              ".quantity__rules-cart .loading__spinner"
            ).classList.add("hidden")
          );
      }

      updateQuantityRules(sectionId, html) {
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(
          `Quantity-Form-${sectionId}`
        );
        const selectors = [
          ".quantity__input",
          ".quantity__rules",
          ".quantity__label",
        ];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === ".quantity__input") {
            const attributes = [
              "data-cart-quantity",
              "data-min",
              "data-max",
              "step",
            ];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector("variant-selects");
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          "related-products"
        );
        return document.querySelector(
          `product-recommendations[data-section-id^="${relatedProductsSectionId}"]`
        );
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          "quick_order_list"
        );
        return document.querySelector(
          `quick-order-list[data-id^="${quickOrderListSectionId}"]`
        );
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}

function hideQuickAddIfFormDisabled() {
  const formButton = document.querySelector(".product-form__submit");
  const hiddenButton = document.querySelector(".quick-add-hidden-button");

  if (formButton && hiddenButton) {
    if (formButton.disabled) {
      if (hiddenButton.style.display !== "none") {
        hiddenButton.style.display = "none";
      }
    } else {
      if (hiddenButton.style.display === "none") {
        hiddenButton.style.display = "";
      }
    }
  }
}

function initHoverEffect() {
  const formButton = document.querySelector(".product-form__submit");
  const hiddenBitteWahlenOption = document.querySelector(
    ".quick-add-hidden-button"
  );

  if (formButton && hiddenBitteWahlenOption) {
    hiddenBitteWahlenOption.addEventListener("mouseenter", () => {
      formButton.classList.add("hovered");
    });

    hiddenBitteWahlenOption.addEventListener("mouseleave", () => {
      formButton.classList.remove("hovered");
    });
  }
}

function myInitCode() {
  const formButton = document.querySelector(".product-form__submit");
  const hiddenBitteWahlenOption = document.querySelector(
    ".quick-add-hidden-button"
  );

  if (!formButton || !hiddenBitteWahlenOption) return;

  const observer = new MutationObserver(() => {
    console.log("MutationObserver detected a change in formButton attributes");
    hideQuickAddIfFormDisabled();
  });
  observer.observe(formButton, {
    attributes: true,
    attributeFilter: ["disabled"],
  });

  hideQuickAddIfFormDisabled();

  hiddenBitteWahlenOption.addEventListener("click", (event) => {
    const allSelects = document.querySelectorAll(
      ".product-variant-picker-selector select"
    );
    let productSizeSelect = null;

    // Loop through all selects to find the one with the "bittewahlen" option
    for (let i = 0; i < allSelects.length; i++) {
      const select = allSelects[i];
      const bitteWahlenOption = select.querySelector(
        'option[id="bittewahlen"]'
      );
      if (bitteWahlenOption) {
        productSizeSelect = select;
        break;
      }
    }
    const klaviyoButton = document.querySelector(
      "a.button.klaviyo-bis-trigger"
    );

    if (productSizeSelect) {
      if (
        window.getComputedStyle(formButton).display !== "none" &&
        productSizeSelect.value !== "Bitte wählen"
      ) {
        formButton.submit();
      } else if (klaviyoButton && productSizeSelect.value !== "Bitte wählen") {
        if (window.getComputedStyle(klaviyoButton).display !== "none") {
          klaviyoButton.click();
        }
      } else {
        event.preventDefault();
        openSelectDropdown(productSizeSelect);
      }
    }
  });
}

if (document.readyState !== "loading") {
  console.log("document is already ready, just execute code here");
  myInitCode();
  initHoverEffect();
} else {
  document.addEventListener("DOMContentLoaded", function () {
    console.log("document was not ready, place code here");
    myInitCode();
    initHoverEffect();
  });
}

function openSelectDropdown(selectElement) {
  if (selectElement && typeof selectElement.showPicker === "function") {
    selectElement.showPicker();
  } else if (selectElement) {
    const event = new MouseEvent("mousedown", {
      view: window,
      bubbles: true,
      cancelable: true,
    });

    selectElement.dispatchEvent(event);
    setTimeout(() => {
      selectElement.click();
    }, 10);
  }
}
